exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Top-module__wrapper___1tbZk{margin:0 2.25rem}.Top-module__wrapper___1tbZk .Top-module__calender___2U4SE{position:absolute;top:.5rem;right:.5rem}", ""]);

// exports
exports.locals = {
	"wrapper": "Top-module__wrapper___1tbZk",
	"calender": "Top-module__calender___2U4SE"
};